module.exports = "/_next/static/images/7ad5cd3df2b6bd0d8b04577baf06d080-fogafin.png";